export default "__VITE_ASSET__eNEdt1Lt__"